// extracted by mini-css-extract-plugin
export default {"invoices":"InvoicePage_invoices__OwQY4","back":"InvoicePage_back__XWYZP"};